import { createReducer } from '@reduxjs/toolkit';

import { ActionFailureType, ActionSuccessType, GET_SITE_CUSTOM_PAGES } from 'constants/redux-actions';

const initState = [];

const customPagesReducer = createReducer(initState, {
  [ActionSuccessType(GET_SITE_CUSTOM_PAGES)]: (_, action) => action.payload.data,
  [ActionFailureType(GET_SITE_CUSTOM_PAGES)]: () => [],
});

export default customPagesReducer;
